// Busmarke der Karten (Live-Karte des Dashboards und Live-Tracking; Stile .ov-bus* in bedienelemente.css): weißes
// Rechteck mit Liniennummer, optional Richtung (H/R) und dahinter der Zustand der letzten Position
// (Kundenwunsch 13.10.2026, wörtlich „wenn der letzte standort gps übermittlung maximal 3 min her war als pulse effekt
// die punkte hinter der linie. ansonsten einen disconnected blitz in der letzten verspuatungsfarbe ohne pulse. das selbe
// im dashboard“):
// - Position höchstens 3 Minuten alt: Ampelpunkt der Verspätung mit Pulsieren (ov-bus__dot--live);
// - älter oder ohne Zeit: Blitz mit Schrägstrich (Lucide zap-off) in der Farbe der letzten Verspätung, ohne Pulsieren.
// Reine Funktionen ohne Vue; Text nur aus line_id (maskiert).
import { delayLevel } from './overviewData';

// höchstens so alt (Sekunden) gilt die letzte Position als aktuell
export const LIVE_SECONDS = 180;
// Dauer eines Pulses (s, wie ov-bus-puls in bedienelemente.css): Versatz je Bus innerhalb dieser Dauer
const PULSE_SECONDS = 1.8;

// Lucide zap-off (ISC), Strich in currentColor
const BOLT_PATHS = '<path d="M10.513 4.856 13.12 2.17a.5.5 0 0 1 .86.46l-1.377 4.317"></path>'
  + '<path d="M15.656 10H20a1 1 0 0 1 .78 1.63l-1.72 1.773"></path>'
  + '<path d="M16.273 16.273 10.88 21.83a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14H4a1 1 0 0 1-.78-1.63l4.507-4.643"></path>'
  + '<path d="m2 2 20 20"></path>';

export function escapeHtml(value) {
  return String(value).replace(/[&<>"']/g, ch => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));
}

// Versatz des Pulses je Bus (Kundenwunsch 13.10.2026: „der pulls bei allen immer leicht versetzt zufällig damit nicht
// alle gleichzeitig pulsieren“): zufällig wirkend, aber fest aus Drucker bzw. Linie und Position abgeleitet, damit der
// Takt beim Neuladen (Live-Tracking alle 15 s) nicht springt; negativ, damit der Puls sofort läuft
function pulseDelay(row) {
  const key = String(row.printer_id || '') + '|' + String(row.line_id || '') + '|'
    + (row.printer_id ? '' : String(row.latitude) + ',' + String(row.longitude));
  let h = 2166136261;
  for (let i = 0; i < key.length; i += 1) {
    h ^= key.charCodeAt(i);
    h = Math.imul(h, 16777619) >>> 0;
  }
  return -((h % 1000) / 1000 * PULSE_SECONDS).toFixed(2) + 's';
}

export function hasLine(row) {
  return !!row && row.line_id !== null && row.line_id !== undefined && row.line_id !== '';
}

// Letzte Position höchstens LIVE_SECONDS vor dem Bezugszeitpunkt now (ms; Live-Tracking mit gewähltem Zeitpunkt: dieser)
export function isLive(row, now) {
  const t = row && row.time ? Date.parse(row.time) : NaN;
  if (!isFinite(t)) {
    return false;
  }
  const age = now - t;
  return age <= LIVE_SECONDS * 1000 && age >= -LIVE_SECONDS * 1000;
}

// HTML der Marke; options: direction ('H' | 'R' | ''), now (ms), dim (abgeblendet)
export function busMarkHtml(row, options) {
  const opts = options || {};
  const level = delayLevel(row);
  const line = hasLine(row) ? escapeHtml(row.line_id) : '?';
  const direction = opts.direction ? '<span class="ov-bus__dir">' + escapeHtml(opts.direction) + '</span>' : '';
  const state = isLive(row, opts.now)
    ? '<span class="ov-bus__dot ov-bus__dot--' + level + ' ov-bus__dot--live" style="--puls-delay:' + pulseDelay(row) + '"></span>'
    : '<svg class="ov-bus__bolt ov-bus__bolt--' + level + '" viewBox="0 0 24 24" fill="none" stroke="currentColor"'
      + ' stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">'
      + BOLT_PATHS + '</svg>';
  return '<span class="ov-bus__mark' + (opts.dim ? ' ov-bus__mark--dim' : '') + '">' + line + direction + state + '</span>';
}
